import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import { FeatureFlag } from 'react-launch-darkly';

// Helpers
import { openExamDirect } from '../../helpers/helpers';

// Components
import * as icons from '../Icons/Icons';
import Pricing from './Pricing';
import Payments from '../Payments/Payments';
import SessionStartAutomated from '../SessionStart/SessionStartAutomated';

const ScheduleAutomated = observer(class ScheduleAutomated extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.setFees = this.setFees.bind(this);
    this.renderPricingButton = this.renderPricingButton.bind(this);
    this.submitSchedule = this.submitSchedule.bind(this);
    this.showConfirmation = this.showConfirmation.bind(this);
  }

  componentWillMount() {
    const { automatedOnly, store, examSid, sessionSid } = this.props;
    const { PaymentStore, ProctorStore, SessionStore } = store;
    const { installSid } = SessionStore.userData;

    // If this is an automated-only session, hide the header and footer
    // because the scheduling flow is in its own tab
    if(automatedOnly) {
      SessionStore.hideHeader = true;
      SessionStore.hideFooter = true;
    }

    this.state = {
      fees: null,
      voucherCode: null,
      accessCode: null,
      examUrl: ''
    }

    if(this.props.status.toLowerCase() !== 'scheduled') {
      this.setState({
        step: 1
      });
    } else {
      this.setState({
        step: 4
      });
    }

    if(this.props.accessCode) {
      this.setState({
        accessCode: this.props.accessCode
      });
    }

    openExamDirect(installSid, examSid, sessionSid)
      .then(response => this.setState({ examUrl: response.redirectUrl }));

    // Set payment callback
    PaymentStore.setAfterPayment((event) => this.nextStep(event));

    // Get the pricing data
    const _this = this;
    setTimeout(function(){
      const query = `?proctorLocationSids=${_this.props.proctorLocationSid}&examSessionSid=${_this.props.sessionSid}`;

      ProctorStore.searchProctors(query, _this.setFees, null);
    });

    this.props.store.SessionStore.getCurrentTime();
  }

  setFees(i, data) {
    this.setState({
      fees: data[0].fees
    });
  }

  setStep(e, step) {
    const { automatedOnly, setClosePath } = this.props;

    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    }, () => {
      if(!automatedOnly) {
        setClosePath('/');
      }
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  isActive(step) {
    if(this.state.step === step) {
      return true;
    } else {
      return false;
    }
  }

  statusClass(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  renderPricingButton() {
    const { translation } = this.props;

    if(this.state.fees) {
      if(this.state.fees.userTotal > 0) {
        return (
          <button
            className="btn"
            onClick={(e) => {this.nextStep(e)}}
          >
            {translation.next}
          </button>
        )
      }
    }

    return null;
  }

  submitSchedule() {
    const { store, proctorTypeSubCategorySid } = this.props;
    const { ExamStore, ScheduleStore } = store;

    const data = {
      amount: this.state.fees.userTotal,
      currency: this.state.fees.currencyCode,
      type: 'automated',
      appointmentDateTime: moment(ExamStore.examSession.examConfiguration.examCloseDate).subtract(1, 'minutes').toISOString(),
      proctorLocationSid: this.props.proctorLocationSid,
      proctorTypeSubCategorySid
    }

    if(!this.state.scheduleSubmitted) {
      this.setState({
        scheduleSubmitted: true
      }, () => {
        ScheduleStore.createAppointment(this.props.examSid, this.props.sessionSid, data, this.showConfirmation)
      });
    }
  }

  showConfirmation(response) {
    this.setStep(null, 4);

    this.setState({
      accessCode: response.data.accessKey
    });
  }

  renderStart = hybrid => {
    const { exam } = this.props.store.ExamStore;

    return (
      <SessionStartAutomated
        {...this.props}
        exam={exam}
        hybrid={hybrid}
      />
    )
  }

  render() {
    const { translation } = this.props;
    const { ExamStore, SessionStore } = this.props.store;

    let examOpen = true;

    const now = moment(this.props.store.SessionStore.currentTime);
    const openDate = moment(ExamStore.examSession.examConfiguration.examOpenDate);
    const openDiff = moment.duration(openDate.diff(now)).asHours();

    if(openDiff >= 0) {
      examOpen = false;
    }

    if(!SessionStore.backgroundLoading && this.state.step !== 5) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <div className={`panel panel--brief ${this.statusClass(1)}`}>
            <h2 className="panel__title">{translation.requirements.heading}</h2>

            <p>{translation.requirements.body_pre}</p>

            <p>{translation.requirements.body_post}</p>

            <ul>
              {translation.requirements.requirement_list.map(
                (requirement, i) =>
                <li key={i}>{requirement}</li>
              )}
            </ul>

            <button
              className="btn"
              onClick={(e) => {this.nextStep(e)}}
            >
              <icons.iconCalendarPlus />
              {translation.requirements.button}
            </button>
          </div>

          <div className={`panel panel--brief ${this.statusClass(2)}`}>
            {this.state.fees && this.state.fees.userTotal !== 0 &&
              <div>
                <Pricing fees={this.state.fees} scheduler={this} {...this.props} />

                {this.renderPricingButton()}

                <span className="preposition--vertical">{translation.pricing.or}</span>

                <button
                  className="btn--link"
                  onClick={(e) => {this.prevStep(e)}}
                >
                  {translation.go_back}
                </button>
              </div>
            }

            {this.state.fees && this.state.fees.userTotal === 0 &&
              <div>
                {this.state.step === 2 && this.submitSchedule()}
                <span className="loader-bar">Loading…</span>
              </div>
            }
          </div>

          <div className={`panel panel--brief ${this.statusClass(3)}`}>
            <h2 className="panel__title">{translation.payment.heading}</h2>

            <Payments submit={this.submitSchedule} {...this.props} />
          </div>

          <div className={`panel panel--brief ${this.statusClass(4)}`}>
            <h2 className="panel__title">{translation.confirmed.heading}</h2>


            {examOpen &&
              <div>
                <p>{translation.confirmed.body_open}</p>

                <div className="actions panel__actions">
                  <a
                    className="btn actions__btn"
                    target="_top"
                    rel="opener"
                    href={this.state.examUrl}
                  >
                    {translation.confirmed.start_now}
                  </a>

                  <Link
                    className="btn btn--outline actions__btn"
                    to="/"
                    onClick={() => {SessionStore.hideDrawerClose = false}}
                  >
                    {translation.confirmed.start_later}
                  </Link>
                </div>
              </div>
            }

            {!examOpen &&
              <div>
                <p>{translation.confirmed.body_closed}</p>

                <Link
                  className="btn--link"
                  to="/"
                  onClick={() => {SessionStore.hideDrawerClose = false}}
                >
                  {translation.confirmed.dashboard}
                </Link>
              </div>
            }

            <Link
              className="btn--link"
              to="/"
              onClick={() => {SessionStore.hideDrawerClose = false}}
            >
              {translation.confirmed.button}
            </Link>
          </div>
        </div>
      );
    } else if(this.state.step === 5) {
      return (
        <FeatureFlag
          flagKey="hybrid"
          renderFeatureCallback={this.renderStart}
          renderDefaultCallback={this.renderStart}
        />
      )
    }

    return null;
  }
})

export default translate('ScheduleAutomated')(ScheduleAutomated);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ScheduleAutomated.js